import * as React from 'react';

import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import BelfiusCurrencyText from './belfius-currency-text';
import { Currency } from '../../store/shared/types';

interface StaticInformationProps {
  readonly headerText: string;
  readonly headerColor?: string;
  readonly headerSize?: string;
  readonly information: { [key: string]: string | Currency | boolean | number | undefined };
  readonly translation?: string;
  readonly fiftySplit?: boolean;
}

const styles = {
  informationContainer: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    marginLeft: '10px'
  },
  informationKeys: {
    flex: '1 1',
    justifyContent: 'start',
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'row' as 'row'
  },
  keyContainer: {
    flex: '1 1'
  },
  key: {
    justifyContent: 'start',
    alignItems: 'start',
    flexDirection: 'column' as 'column',
    fontSize: '12pt',
    fontWeight: 'bolder' as 'bolder'
  },
  valueContainer: {
    flex: '2 2'
  },
  valueContainerFiftySplit: {
    flex: '1 1'
  },
  value: {
    fontSize: '12pt'
  }
};

class StaticInformation extends React.PureComponent<StaticInformationProps> {

  private localization: Ii18n;

  constructor(props: StaticInformationProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    const numberOfElements = Object.values(this.props.information).filter(x => x).length;
    if (numberOfElements === 0) {
      return null;
    }

    const headerTranslation = this.localization.get(this.props.headerText);
    const header = (
      <h2 style={{ color: this.props.headerColor ? this.props.headerColor : '#aa0024', fontSize: this.props.headerSize ? this.props.headerSize : '' }}>
        {headerTranslation ? headerTranslation : this.props.headerText}
      </h2 >
    );

    const info = Object.keys(this.props.information).map((key, i) => {
      if (this.props.information[key] !== null && this.props.information[key] !== undefined) {
        const translationTerm = this.localization.get(`${this.props.translation}.${key}`);
        let value = this.props.information[key];
        if (typeof value === 'boolean') {
          value = value ? this.localization.get('shared.yes') : this.localization.get('shared.no');
        }
        return (
          <div style={styles.informationKeys} key={"a_" + i.toString()}>
            <div style={styles.keyContainer} key={"c_" + i.toString()}>
              <span style={styles.key}>{translationTerm ? translationTerm : key}: </span>
            </div>
            <div key={"d_" + i.toString()} style={this.props.fiftySplit ? styles.valueContainerFiftySplit : styles.valueContainer}>
              {value instanceof Currency ? <BelfiusCurrencyText value={value.amount} suffix={value.suffix} prefix={value.prefix} /> : <span key={"e_" + i.toString()} style={styles.value}>{value}</span>}
            </div>
          </div>
        );
      } else {
        return (
          <div style={styles.informationKeys} key={"b_" + i.toString()} />
        );
      }
    });

    return (
      <div>
        {header}
        <div style={styles.informationContainer}>
          {info}
        </div>
        <br />
      </div>
    );
  }
}

export { StaticInformation };
